module.exports = __webpack_public_path__ + "static/settings-96d9b6051c8f852d2296b62922f19485.mp4";